export default __webpack_public_path__ + "static/media/pata.419fdf8c.png";